var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationsMobileNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.75L15.1627 2.1195C15.5055 2.196 15.75 2.49975 15.75 2.8515V10.3417C15.75 11.8462 14.9977 13.2517 13.746 14.0858L9 17.25L4.254 14.0858C3.0015 13.251 2.25 11.8463 2.25 10.3425V2.8515C2.25 2.49975 2.4945 2.196 2.83725 2.1195L9 0.75ZM9 2.28675L3.75 3.453V10.3417C3.75 11.3445 4.251 12.2812 5.08575 12.8378L9 15.4478L12.9142 12.8378C13.749 12.2812 14.25 11.3453 14.25 10.3425V3.453L9 2.2875V2.28675ZM12.339 6.1665L13.4003 7.227L8.62725 12L5.445 8.81775L6.5055 7.75725L8.6265 9.87825L12.339 6.16575V6.1665Z",
    fill: "#080917"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationsMobileNav);
export default __webpack_public_path__ + "static/media/verifications-mobile-nav.d914c06057e94af18e86179529e334a9.svg";
export { ForwardRef as ReactComponent };